import React, {
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
} from "react";
import { AuroraIconProps, Sizes } from "./AuroraIcon";
import styles from "../styles.module.scss";

type Components = Record<
  string,
  ForwardRefExoticComponent<AuroraIconProps & RefAttributes<SVGSVGElement>>
>;

const sizeMap: Sizes = {
  xs: "16",
  s: "24",
  m: "32",
  l: "56",
};

const LightbulbOutline24 = forwardRef<SVGSVGElement, AuroraIconProps>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    className={[styles.auIcon, styles.auIcon24, "auIcon", "auIcon24", props.className].join(" ")}
    focusable={false}
    ref={ref}
  >
    <path d="M9 20h6v2H9zM12 2c-.46 0-.93.04-1.4.14-2.75.53-4.96 2.77-5.47 5.52-.48 2.61.48 5.01 2.22 6.56.42.37.65.91.65 1.47V19h8v-3.31c0-.55.22-1.09.64-1.46A6.96 6.96 0 0 0 19 8.99c0-3.87-3.13-7-7-7Zm3.31 10.74c-.83.74-1.31 1.82-1.31 2.96v1.31h-1v-6.59l1.71-1.71L13.3 7.3l-1.29 1.29-1.29-1.29-1.41 1.41 1.71 1.71v6.59h-1V15.7c0-1.13-.48-2.22-1.32-2.96-1.32-1.18-1.91-2.94-1.59-4.7C7.47 6.1 9.07 4.49 11 4.11c.34-.07.69-.1 1.02-.1 2.76 0 5 2.24 5 5 0 1.43-.61 2.79-1.69 3.74Z" />
  </svg>
));

const LightbulbOutline32 = forwardRef<SVGSVGElement, AuroraIconProps>((props, ref) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="32"
    height="32"
    className={[styles.auIcon, styles.auIcon32, "auIcon", "auIcon32", props.className].join(" ")}
    focusable={false}
    ref={ref}
  >
    <path d="M13 28h6v2h-6zM11 25h10v2H11zM16 2q-.57 0-1.14.06c-4.62.51-8.36 4.3-8.81 8.93a9.96 9.96 0 0 0 4.13 9.12c.52.37.83.97.83 1.61v2.27h10v-2.27c0-.64.3-1.24.82-1.61a9.96 9.96 0 0 0 4.18-8.12c0-5.52-4.48-10-10-10Zm4.65 16.5A3.99 3.99 0 0 0 19 21.73V22h-2v-8.59l2.71-2.71-1.41-1.41-2.29 2.29-2.29-2.29-1.41 1.41 2.71 2.71V22h-2v-.27c0-1.28-.62-2.49-1.66-3.24-2.35-1.69-3.58-4.42-3.3-7.3.36-3.67 3.38-6.73 7.04-7.14.31-.03.62-.05.92-.05 4.41 0 8 3.59 8 8 0 2.57-1.25 5-3.35 6.5Z" />
  </svg>
));
;

const components: Components = { "24": LightbulbOutline24,
"32": LightbulbOutline32 };

const LightbulbOutlineComponent: ForwardRefExoticComponent<
  AuroraIconProps & RefAttributes<SVGSVGElement>
> = forwardRef<SVGSVGElement, AuroraIconProps>(
  (
    {
      size = LightbulbOutline.getSizes().includes("s")
        ? "s"
        : LightbulbOutline.getSizes()[0],
      ...rest
    },
    ref
  ) => {
    try {
      const Tag = components[sizeMap[size] || parseInt(size)];
      if (!Tag) {
        console.error(
          `The icon LightbulbOutline does not have the size "${size}".`
        );
        return <React.Fragment />;
      }
      return <Tag {...rest} ref={ref} />;
    } catch (e) {
      console.error(
        `The icon LightbulbOutline does not have the size "${size}".`,
        e
      );
      return <React.Fragment />;
    }
  }
);

const LightbulbOutline = Object.assign(LightbulbOutlineComponent, {
  getSizes: (): string[] => ["s", "m"],
});

export default LightbulbOutline;
